import { useState, useEffect } from 'react';
import teamsMap from '../constants/teamsMap';
import { Button, Input, Label, Loader, Message, Menu, MenuItem } from 'semantic-ui-react';
import { useParams, useNavigate } from 'react-router-dom';
import request from '../utils/request';
import ImageUploader from '../components/ImageUploader';

export default () => {
  const navigate = useNavigate();
  const params = useParams();
  const team = teamsMap.byExternal[params.extTeamId];
  const [background, setBackground] = useState('');

  useEffect(() => {
    if (!team) {
      navigate('/teams', { replace: true });
    }
  }, [team, navigate]);

  if (!team) { return; }
  return (
    <div className="team-page">
      <h2>{team.name}</h2>
      <Color teamID={team.id} setBackground={setBackground} />
      <ImageUploader path={`logos/${team.abbrev}-centered.png`} background={background} />
      <ImageUploader path={`logos/${team.abbrev}-away.png`} background={background} />
      <ImageUploader path={`logos/${team.abbrev}-home.png`} background={background} />
      <ImageUploader path={`logos/${team.abbrev}-centered2.png`} background={background} />
    </div>
  );
};

const Color = ({ teamID, setBackground }) => {
  const [loading, setLoading] = useState();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(true);
  const [primaryColor, setPrimaryColor] = useState('');
  const [secondaryColor, setSecondaryColor] = useState('');
  const [city, setCity] = useState('');
  const [stadium, setStadium] = useState('');
  const [useColor, setUseColor] = useState('transparent');

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError();
      const response = await request('get', `${process.env.REACT_APP_EXPRESS_URL}team?id=${teamID}`);
      if (response.error) {
        setError(response.errorMessage);
      } else {
        setPrimaryColor(response.primaryColor || '');
        setSecondaryColor(response.secondaryColor || '');
        setCity(response.city || '');
        setStadium(response.stadium || '');
      }
      setLoading(false);
    }
    fetchData();
  }, [teamID]);

  async function save() {
    if (!/^#[0-9A-F]{6}$/.test(primaryColor)) {
      setError('Primary color isn\'t a valid HEX code');
      return;
    }
    if (!/^#[0-9A-F]{6}$/.test(secondaryColor)) {
      setError('Secondary color isn\'t a valid HEX code');
      return;
    }
    setError();
    setSaving(true);
    const response = await request('patch', `${process.env.REACT_APP_EXPRESS_URL}team?id=${teamID}`, {
      primaryColor,
      secondaryColor,
      city,
      stadium,
    });
    if (response.error) {
      setError(response.errorMessage);
    }
    setSaving(false);
  }

  function _setPrimaryColor(_, { value }) {
    setPrimaryColor(value);
    _setBackground(useColor, value, secondaryColor);
  }

  function _setSecondaryColor(_, { value }) {
    setSecondaryColor(value);
    _setBackground(useColor, primaryColor, value);
  }

  function _setUseColor(value) {
    setUseColor(value);
    _setBackground(value, primaryColor, secondaryColor);
  }

  function _setBackground(_useColor, _primaryColor, _secondaryColor) {
    let color = '';
    if (_useColor === 'primary') {
      if (/^#[0-9A-F]{6}$/.test(_primaryColor)) {
        color = _primaryColor;
      }
    } else if (_useColor === 'secondary') {
      if (/^#[0-9A-F]{6}$/.test(_secondaryColor)) {
        color = _secondaryColor;
      }
    }
    setBackground(color);
  }

  const useColorOptions = [
    { name: 'transparent', title: 'Transparent' },
    { name: 'primary', title: 'Primary' },
    { name: 'secondary', title: 'Secondary' },
  ];

  return <div className="team-colors">
    {loading ? <Loader active /> : null}
    <Input
      placeholder="#000000"
      labelPosition="left"
      value={primaryColor}
      error={!/^#[0-9A-F]{6}$/.test(primaryColor)}
      onChange={_setPrimaryColor}
      disabled={loading || saving}
    >
      <Label>Primary Color</Label>
      <input />
    </Input>
    <Input
      placeholder="#000000"
      labelPosition="left"
      value={secondaryColor}
      error={!/^#[0-9A-F]{6}$/.test(secondaryColor)}
      onChange={_setSecondaryColor}
      disabled={loading || saving}
    >
      <Label>Secondary Color</Label>
      <input />
    </Input>
    <Input
      placeholder="City"
      labelPosition="left"
      value={city}
      onChange={(_, { value }) => setCity(value)}
      disabled={loading || saving}
    >
      <Label>City</Label>
      <input />
    </Input>
    <Input
      placeholder="Stadium"
      labelPosition="left"
      value={stadium}
      onChange={(_, { value }) => setStadium(value)}
      disabled={loading || saving}
    >
      <Label>Stadium</Label>
      <input />
    </Input>
    <Button
      primary
      onClick={save}
      loading={saving}
      disabled={loading || saving}
    >
      Save settings
    </Button>
    <Menu secondary>
      <MenuItem header>Set Background</MenuItem>
      {useColorOptions.map(({ name, title }) => <MenuItem
        key={name}
        active={useColor === name}
        onClick={() => _setUseColor(name)}
        disabled={loading}
      >
        {title}
      </MenuItem>)}
    </Menu>
    {error ? <Message error><span>{error}</span></Message> : null}
  </div>;
};
